<div class="fullpage narrative" *ngIf="key">
    <h1>{{chapter.title}}</h1>
    <div>{{key}}</div>
    <app-listen-track *ngIf="chapter.audio" [src]="chapter.audio"></app-listen-track>
    <app-watch-video *ngIf="chapter.video" [src]="chapter.video"></app-watch-video>
</div>
